import { createHtmlContainer, waitForContentLoad, validateContent, cleanupContainer, cleanupOnError } from './htmlContainer';
import { renderHtmlToCanvas } from './canvasRenderer';
import { createPdfFromCanvas, createPdfBlob } from './pdfGenerator';
import { downloadBlob } from './downloadManager';

/**
 * تحويل HTML إلى PDF وتنزيله
 */
export const renderHtmlToPDF = async (htmlContent: string, fileName: string): Promise<boolean> => {
  let containerDiv: HTMLDivElement | null = null;
  
  try {
    console.log('🔄 بدء عملية إنشاء PDF...');
    console.log('📄 طول محتوى HTML:', htmlContent.length);
    console.log('📁 اسم الملف:', fileName);
    
    // التحقق من المتطلبات
    if (!htmlContent || htmlContent.trim().length === 0) {
      throw new Error('محتوى HTML فارغ');
    }
    
    console.log('📝 إنشاء HTML Container...');
    // إنشاء الـ container وإضافة المحتوى
    containerDiv = createHtmlContainer(htmlContent);
    console.log('✅ تم إنشاء HTML Container بنجاح');
    
    console.log('⏳ انتظار تحميل المحتوى...');
    // انتظار تحميل المحتوى
    await waitForContentLoad();
    console.log('✅ تم تحميل المحتوى بنجاح');
    
    console.log('🔍 التحقق من صحة المحتوى...');
    // التحقق من صحة المحتوى
    validateContent(containerDiv);
    console.log('✅ تم التحقق من صحة المحتوى');
    
    console.log('📸 تحويل HTML إلى Canvas...');
    // تحويل HTML إلى Canvas
    const canvas = await renderHtmlToCanvas(containerDiv);
    console.log('✅ تم تحويل HTML إلى Canvas بنجاح');
    
    console.log('📋 إنشاء PDF من Canvas...');
    // إنشاء PDF من Canvas
    const pdf = createPdfFromCanvas(canvas);
    console.log('✅ تم إنشاء PDF بنجاح');
    
    console.log('📦 إنشاء PDF Blob...');
    // إنشاء Blob من PDF
    const pdfBlob = createPdfBlob(pdf);
    console.log('✅ تم إنشاء PDF Blob بنجاح');
    
    console.log('🧹 تنظيف HTML Container...');
    // إزالة الـ container
    cleanupContainer(containerDiv);
    containerDiv = null;
    console.log('✅ تم تنظيف HTML Container');
    
    console.log('💾 بدء تنزيل الملف...');
    // تنزيل الملف
    downloadBlob(pdfBlob, fileName);
    console.log('✅ تم تنزيل الملف بنجاح');
    
    console.log('🎉 تم إكمال عملية إنشاء PDF بنجاح');
    return true;
    
  } catch (error) {
    console.error('❌ خطأ عام في إنشاء PDF:', error);
    console.error('📍 تفاصيل الخطأ:', {
      message: error instanceof Error ? error.message : 'خطأ غير معروف',
      stack: error instanceof Error ? error.stack : undefined,
      htmlLength: htmlContent?.length || 0,
      fileName: fileName
    });
    
    // تنظيف الـ container في حالة الخطأ
    if (containerDiv) {
      console.log('🧹 تنظيف Container في حالة الخطأ...');
      cleanupContainer(containerDiv);
    }
    cleanupOnError();
    
    throw error;
  }
};